export default {
  header: {
    header_home: '首页',
    header_development_document: '开发文档',
  },
  title: {

    CreationAddress:'创世地址',
    createUser: '创建用户',
    block_hash: '区块hash',
    browser: '浏览器',
    Main_chain_block_height: '主链块高',
    // chain:'所在链',
    no_deal_found: '找不到交易',
    session: '届',
    current_committee_rounds: '当前委员会参选轮次',
    committee_information: '委员会信息',
    whole_network_transaction: '全网交易',
    consensus_committee_candidate_round: '共识委员会参选轮次',
    current_block_height: '当前块高',
    details: '详情',
    intra_block_transactions: '块内交易',
    block_height: '块高',
    current_total: '当前共',
    transactions: '条交易',
    hold_details: '持有详情',
    external_transaction: '外部交易',
    Inside_transaction: '内部交易',
    node_information: '节点信息',
    welcome_to_Blockchain_Explorer: '欢迎来到XXX区块链浏览器',
    management_fee: '管理费',
    chain_details: '链详情',
    node_status: '节点状态',
    more: '更多',
    node: '节点',
    inquire: '查询',
    transform: '转换',
    contract_token_details: '合约通证详情',
    current_address_holdings_of_each_token: '当前地址各通证持有量',
    transfer: '转账',
    other_token_transfer: '其他通证转账',
    token_name: '通证名称',
    icon: '图标',
    token_details: '通证详情',
    billion: '亿',
    mining_pool: '共识节点(矿池) >',
    mining_pool_2: '矿池',
    mining_pool_node: '共识节点(矿池)',
    mining_pool_name: '共识节点(矿池)',
    mining_pool_detail: '共识节点(矿池)详情',
    data_node: "数据节点 >",
    data_node_2: "数据节点",
    data_node_detail: "数据节点详情",
    consensus_node: "共识节点(独立) >",
    consensus_node_2: "共识节点(独立)",
    consensus_node_detail: "共识节点(独立)详情",
    task_chain: '任务链',
    trading_chain: '账户链',
    trading_height: '交易列表',
    blockchain_details: '区块链详情',
    transaction_details: '交易详情',
    block_details: '区块详情',
    block_details_query: '区块详情查询',
    transaction_details_inquiry: '查询',
    thk_price: 'TKT价格',
    network_market_value: '网络市值',
    total_online_transaction_volume: '全网交易总量',
    view_transaction: '查看所有交易',
    trading_information: '交易信息',
    trading_count: '交易数量',
    main_chain: '主链',
    main_chain_mining: '主链挖矿中',
    block_height: '区块高度',
    block: '区块',
    transaction: '交易',
    current_committee_member: '当前委员会成员',
    number_of_sub_chains: '任务链数',
    split_subchain: '已分片任务链',
    split_subchain_id: '交易链ID',
    unfragmented_subchain: '未分片任务链',
    see_more_deals: '查看更多交易',
    miner: '矿工',
    whole_network_transaction_information: '全网交易信息',
    block_information: '区块信息',
    slice_chain_information: '交易链信息',
    slice_chain_transaction_information: '交易链交易信息',
    current_chain_transaction_information: '本链交易信息',
    mining_reward: '挖矿奖励',
    parent_block_hash: '父块哈希',
    participation_round: '参选轮次',
    number_of_committees: '委员会人数',
    participant_member_details: '参选成员详情',
    input_data: '输入数据',
    inverse_solution: '反解数据',
    address_de: '地址详情',
    amount: '金额',
    check_content: '支票内容',
    rpt: '关联交易',
    return_address: '返还地址',
    look_over: '查看',
    mine_number: '矿池数量 >',
    view_all: '查看全部 >',
    by: '由',
    to: '到',
    unpack: '打包',
    unpack_node: '打包节点',
    block_contains: '块内含',
    transactions: '笔交易',
    chainId: '链ID',
    viewMores: '显示更多',
    all: '全部',
    transfer_out: '转出',
    transfer_into: '转入',
    cross_chain_transfer: '跨链转账',
    related_to_me: '与我相关',
    success: '成功', //failure
    failure: '失败',
    Sent_awaiting_verification: '已发送，等待验证',
    locked: '',
    pos_locking: 'PoS锁定',
    // pos_reward_chain: 'PoS发奖链',
    pos_reward_chain: 'PoS链',
    new_ecology_business_chain: '商业链',
    amount_detail: '金额明细',
    from: '从',
    transfer_to: '转移至',
    receiving_address: '接收地址',
    prize_amount: '发奖金额',
    redemption_address: '赎回地址',
    redemption_amount: '赎回金额',
    receive_amount: '领奖金额',
    address: '地址',
    no_transaction: '暂无交易',
    no_more: '暂无更多',
    loading: '正在加载...',
    holdings: '持有量',
    total_amount_of_tokens: '代币总量',
    contract_address: '合约地址',
    number_of_accounts: '账号数量',
    quantity: '数量',
    total: '共 xxx 个',
    pub: 'Pub区块链开发辅助平台',
    userList: '用户列表',
    Username_can_not_be_empty:'用户名不能为空',
    Password_cannot_be_less_than_5_digits:'密码不能小于5位',
    RPC_service: "RPC服务",
    address: "地址",
    chain: "链",
    default: '默认',
    Account: '账户',
    create: '创建',
    Please_enter_the_file_name: '请输入文件名',
    Main_sol: '必需文件Main.sol，否则将无法保存！',
    Solidity5: 'Solidity版本0.5.0',
    Are_you_sure: "你确定吗？",
    Delete: "删除",
    want_to_delete: "你确定你要删除",
    cannot_be_undone: "此操作无法撤消！",
    Ispublic: "是否公开:",
    Contract_description: "合约描述:",
    version: "版本号:",

    Save_as_contract_template: '保存为合约模板',
    Reward_on_POS_chain: 'POS 链上发奖',
    POS_node_awards: 'POS 节点发奖',
    Please_enter_the_address: "请输入地址",
    Please_enter_the_correct_address: "请输入正确地址",
    Select_or_enter_the_query_address: "选择或输入查询地址",
    Please_enter_input: "请输入input",
    Serial_number: "序号",
    name: "名称",

    Chain_id: "链id",
    nonce: "Nonce",
    Balance: "余额",
    Creation_time: "创建时间",
    time: '时间',
    operate: "操作",
    common: "共",
    strip: "条",
    Check: "查看",
    title: "提示",
    Public_key: "公钥",
    Private_key: "私钥",
    Cancel: "取消",
    Sure: "确定",
    Contract_name: "合约名称",
    Please_enter_the_contract_name: "请输入合约名称",
    publisher: "发布人",
    Contract_template: "合约模板",
    NewaddContract_template: "新增合约模板",
    ReviseContract_template: "修改合约模板",
    username: "用户名",
    Please_enter_username: "请输入用户名",
    Please_enter_password: "请输入密码",
    login: '登录',
    Private_key_or_mnemonic: "私钥或助记词",
    Do_not_enter_the_default_creation_private_key: "不输入默认创建私钥",
    Check_balances: "查询余额",
    search_history: "搜索历史",
    cannot_be_empty:"进行查询余额操作地址不能为空！",
    logout:"请选择是否继续进行注销操作？",
    information: "消息",
    Compile: "编译",
    Run: "运行",
    Add_to: "添加",
    Revise: "修改",
    Remark: "备注",
    Please_enter_a_note: "请输入备注",
    release: "发布",
    Publish_hash: "发布hash",
    Contract_address: "合约地址",
    Publisher_address: "发布人地址",
    TKM_before_launch: "发布前TKM",
    Post_launch_TKM: "发布后TKM",
    Gas_fee: "Gas费",
    release_time: "发布时间",
    state: "状态",
    Refresh: "刷新",
    No_data: "暂无数据",
    environment: "环境",
    Self_built: "自建",
    system: "系统",
    local: "本地",
    contract: "合约",
    XTO_quantity: "XTO数量",
    UserA_to_userB0: "请首先选中合约，用户A向用户B转账 用户B地址可选可输入",
    UserA: "用户A",
    UserA_address: "用户A地址",
    UserB: "用户B",
    UserB_address: "用户B地址",
    designated_address: "指定地址,",
    designated_placeholder1: "批量转格式：",
    designated_placeholder2: "地址,余额;",
    designated_placeholder3: "例如：",
    Please_enter_the_number_ofXTO: "请输入XTO数量",
    transfer: "转账",
    Award: "发奖",
    // Please_enter_the_correct_address_of_the_prize_issuer!:"请输入正确发奖人地址！",
    Transfer_address: "转账方地址",
    Amount_before_transfer: "转账前金额",
    Amount_after_transfer: "转账后金额",
    Payee_address: "收款方地址",
    Amount_before_payment: "收款前金额",
    Amount_after_receipt: "收款后金额",
    Test_case: "测试用例",
    please_choose: "请选择",
    refresh_the_list: "刷新列表",
    Generate_sig: "生成sig",
    Send_sig_transaction: "发送sig交易",
    Please_select_or_enter_Form: "请选择或输入Form",
    Please_select_contract_address: "请选择合约地址",
    Select_sig_type: "选择sig类型",
    Please_select_the_chain: "请选择链",
    Contract_method: "合约方法",
    Method_entry: "方法入参",
    Initiate_transaction: "发起交易",
    Save_the_use_case: "保存用例",
    Delete_use_case: '删除用例',
    Update_use_case: '修改用例',
    Use_case_name: '用例名称',
    Please_enter_the_use_case_name: '请输入用例名称',
    Reverse_input: "反解input",
    theme: "主题",
    Collapse_all: "全部收起",
    Automatically_detect_conversion_addresses: "自动检测转换地址，可批量转换，地址间回车换行",
    Please_enter_user_address: "请输入用户地址",
    Conversion: "转换",
    Please_enter_content: "请输入内容",
    format: "格式化",
    Generate_public_and_private_keys: "生成公私钥",
    Return_public_key_and_address_via_private_key: "通过私钥返回公钥和地址",
    Please_enter_the_private_key: "请输入私钥",
    Obtain: "获取",
    encryption: "加密",
    Decrypt: "解密",
    please_enter: "请输入",
    UserA_to_userB1: "用户A向用户B转账 用户B地址可选可输入",
    Owning_chain: "所属链",
    transfer_amount: "转账金额",
    Please_enter_the_transfer_amount: "请输入转账金额",
    Amount: "金额",
    search: "搜索",
    Please_enter_the_address: "请输入地址",
    Transaction_hash: "交易Hash",
    Timestamp: "时间戳",
    organizer: "发起方",
    receiver: "接收方",
    TransactionType: "交易类型",
    Transfer_transaction: "转账交易",
    Token_award: "代币发奖",
    Contract_release: "合约发布",
    Ordinary_contract_transaction: "普通合约交易",
    PoC_lock: "PoC锁定",
    PoC_awards: "PoC发奖",
    PoC_redemption: "PoC赎回",
    PoS_award: "PoS领奖",
    PoS_lock: "PoS锁定",
    PoS_award: "PoS发奖",
    Transfer_transaction: "转账交易",
    Cross_chain_transaction_withdrawal: "跨链交易取款",
    Cross_chain_transaction_deposit: "跨链交易存款",
    Cross_chain_transaction_cancellation: "跨链交易撤销",
    Contract_transaction: "合约交易",
    In_chain_transactions: "链内交易",
    Cross_chain_transaction: "跨链交易",
    CreateWallet: "创建钱包",
    Mnemonic: "助记词",
    Mnemonic_to_generate_private_key: "助记词生成私钥",
    Enter_the_mnemonic: "输入助记词",
    Private_key_export_public_key: "私钥导出公钥",
    Enter_private_key: "输入私钥",
    Public_key_export_address: "公钥导出地址",
    Enter_public_key: "输入公钥",
    Wallet_generator: "钱包生成器",
    Method_call: "方法调用",
    SDK_download: "SDK下载",
    sig_type: "sig类型",
    Transaction_amount: "交易金额",
    Please_enter0x: "请输入0x开头的私钥",
    Read_before_downloading: "下载前阅读",
    Read_before_downloading1: "1、电脑配置node.js(建议版本12.15.0)。地址：",
    Read_before_downloading2: "2、全局安装vue-cli(4.x)。控制器里执行：",
    Read_before_downloading3: "3、点击按钮",
    Read_before_downloading_Download: ' SDK (1.0.5):"下载sdk(1.0.5)"',
    Read_before_downloading4: "4、进入sdk项目，安装项目依赖, 根目录执行:npm install",
    Read_before_downloading5: "5、启动项目,项目根目录执行:npm run serve",
    Read_before_downloading6: "6、打包,项目根目录执行:npm run build，生成dist文件",
    Project_file_description: "项目文件说明",
    Interface_docking_instructions: "接口对接说明",
    Interface_document_address: "接口文档地址",
    Interface_docking_instructions1: "注册后，找管理员要权限，查看相应接口文档。",
    Interface_docking_instructions2: "接口文档，调试时，可安装插件，查看回调结果。（类似Postman）",
    Interface_docking_instructions3: "接口，采用AES对私钥加密，发送到合约服务，再发起链交易。",
    Interface_docking_instructions4: "businessId 对应的 AES 密钥，可以找管理员索取。",
    dev_assistant_platform: '开发辅助平台',
    get_contract_releas_code:'获取合约发布code',
    enter_address_compared:'请输入需要比对的地址',
    Compare_addresses: '比对地址',

  },
  prompt: {
    prompt_2: '注：主链和已分片任务链其链上只记录成员选举，不记录一般交易，选举交易数不计入交易链',
  },
  placeholder: {
    placeholder_1: '请输入区块高度',
    placeholder_2: '请输入交易哈希/账户地址',
    placeholder_3: '请输入区块高度/区块哈希',
    placeholder_4: '请输入区块高度/交易哈希/交易地址',
    placeholder_5: '请输入交易哈希',
    placeholder_6: '请输入交易哈希/区块高度/区块哈希查询',
    search: '查询',
    filter: '筛选',
    view_all_blocks: '查看所有区块',
    view_all_tr: '查看所有交易',
    choose: '请选择',
    placeholder_7: '请输入账号地址、交易哈希',
    placeholder_8: '请输入区块hash / 交易hash / 用户地址'
  },
  table: {
    transfer_via_contract: '合约代转账',
    direct_transfer: '直接转账',
    subchain_id: '任务链ID',
    block_height: '区块高度',
    current_committee_member: '当前委员会成员',
    number_of_committee_members: '委员会成员数',
    elected_member: '参选成员',
    number_of_fragments: '分片数量',
    total_share_of_its_segmented_chain: '旗下交易链交易总量',
    miner: '矿工',
    trading_volume: '交易量',
    transaction_hash: '交易哈希',
    own_chain: '所属链',
    timestamp: '时间戳',
    transaction_type: '交易类型',
    initiator: '发起方',
    receiver: '接收方',
    transfer_amount: '转账金额',
    transaction_fee: '交易费用',
    block_hash: '区块hash',
    total_number_of_transactions: '交易总数',
    state: '状态',
    ov_block: '所属区块',
    tr_peo: '转账人',
    send_ch: '发出链',
    get_ch: '接收链',
    input_data: '输入数据',
    is_user: '调用者',
    contract: '合约',
    committee_member_details: '委员会成员详情',
    generated_block_information: '生成的区块信息',
    ac_any: '账户金额',
    ac_any_other: '各任务链金额',
    ac_num: '合约内金额',
    issuer: '发出者',
    recipient: '接收者',
    call_record: '调用记录',
    cross_chain_transfer_contract: '跨链转账合约',
    order: '序号',
    nodeID: '节点ID',
    currentStatus: '当前状态',
    mineID: '矿池ID',
    pitManagementFee: '矿池管理费',
    remainingAmount: '剩余数量',
    TokensTrading: '代币交易',
    token_prizes: '代币发奖',
    token_transfer_accounts: '代币转账',
    has_abandoned_the_award_waiting_for_approval: '已放弃领奖，等待审批',
    have_been_approved: '已审批，通过',
    approved_not_approved: '已审批呢，不通过',
    has_the_prize: '已领奖',

  },
  download: {
    sdkdownload: 'SDK下载',
    apidownload: 'API下载',
    Software_package: '软件包',
    version: '版本',
    size: '大小',
    update_time: '更新时间',
    document_description: '文档说明',
    software_address: '软件地址',
    view: '查看',
    _download: '下载',
  },
  select: {
    all: '全部',
    within_chain_trading: '链内交易',
    contract_trading: '合约交易',
    across_chain_trading: '跨链交易',
    contract_issued: '合约发布',
    common_contract_trading: '普通合约交易',
    other_lock: 'Other锁定',
    poc_prizes: 'PoC发奖',
    poc_redemption: 'PoC赎回',
    poc_generation: 'PoC代投',
    pos_lock: 'PoS锁定',
    pos_prizes: 'PoS发奖',
    pos_award: 'PoS领奖',
    across_chain_trading_withdrawal: '跨链交易取款',
    across_chain_trading_deposit: '跨链交易存款',
    across_chain_trading_repeal: '跨链交易撤销',
    transfer_transaction: '转账交易',
    order_on_chain: '订单上链'
  }

}